"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useIsMounted;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

/**
 *
 * @param {Function} [onUnmount] Pokud je handler definovan, zavola se pri odmontovavani hooku.
 */
function useIsMounted(onUnmount) {
  var ref = (0, _react.useRef)(false);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      setIsMounted = _useState2[1];

  (0, _react.useEffect)(function () {
    ref.current = true;
    setIsMounted(true);
    return function () {
      ref.current = false;
      if (onUnmount) onUnmount();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return ref.current;
}